import React from 'react';
import Report from '../components/Report';

const ReportPage = () => {
	return <Report />;
};

export default ReportPage;
